const initMqDesignPages = () => {
  document.querySelectorAll('[data-mq-design-page]').forEach((page) => {
    if (page.dataset.mqDesignReady) return;
    page.dataset.mqDesignReady = 'true';

    const sv = page.dataset.locale === 'sv';
    const q = (selector) => page.querySelector(selector);
    const qa = (selector) => [...page.querySelectorAll(selector)];
    const params = new URLSearchParams(location.search);
    const form = q('#MqDesignRequestForm');
    const formBody = q('[data-mq-design-form]');
    const sizeStep = q('[data-mq-design-size-step]');
    const uploadStep = q('[data-mq-design-upload-step]');
    const descriptionStep = q('[data-mq-description-step]');
    const descriptionActions = q('[data-mq-description-actions]');
    const contactStep = q('[data-mq-contact-step]');
    const input = q('[data-mq-file-input]');
    const previews = q('[data-mq-previews]');
    const uploadStatus = q('[data-mq-upload-status]');
    const uploadLimit = q('[data-mq-upload-limit]');
    const descriptionNext = q('[data-mq-description-next]');
    const contactOpen = q('[data-mq-contact-open]');
    const requestSubmit = q('[data-mq-request-submit]');
    const status = q('[data-mq-design-status]');
    const contactDetail = q('[data-mq-contact-detail]');
    const contactInput = q('[data-mq-contact-input]');
    const contactLabel = q('[data-mq-contact-label]');
    const contactHelp = q('[data-mq-contact-help]');
    const approval = q('[data-mq-approval]');
    const termsApproval = q('[data-mq-terms-approval]');
    const success = q('[data-mq-success]');
    const errors = q('[data-mq-errors]');
    const cloudinaryEndpoint = 'https://api.cloudinary.com/v1_1/yzgwim4h/image/upload';
    const cloudinaryPreset = 'mq_design_uploads';
    const merchantContactEmail = 'info@mqshields.se';

    if (success) {
      const savedMethod = sessionStorage.getItem('mq-design-contact-method');
      const methodOutput = q('[data-mq-success-method]');
      if (savedMethod && methodOutput) methodOutput.textContent = savedMethod;
      sessionStorage.removeItem('mq-design-contact-method');
      sessionStorage.removeItem('mq-design-request-id');
      page.classList.add('is-success');
      setTimeout(() => success.focus(), 0);
      return;
    }

    let size = params.get('size') || '14';
    let model = params.get('model') || 'gloss-14';
    let modelName = '14 CM';
    let price = '349 KR';
    let selectedFiles = [];
    const uploadedFileUrls = new Map();
    let preparedUploadedUrls = [];
    let isPreparingImages = false;
    let emailFieldsCompacted = false;
    let requestId = sessionStorage.getItem('mq-design-request-id') || '';
    let isSubmitting = false;
    const maxFiles = () => 5;

    const createRequestId = () => {
      if (requestId) return requestId;
      const date = new Date();
      const datePart = [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('');
      const randomPart = Math.random().toString(36).slice(2, 8).toUpperCase();
      requestId = `MQ-${datePart}-${randomPart}`;
      sessionStorage.setItem('mq-design-request-id', requestId);
      return requestId;
    };

    const scrollClean = (element) => {
      if (!element) return;
      const header = document.querySelector('.section-header');
      const offset = (header?.offsetHeight || 0) + 12;
      window.scrollTo({ top: element.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    };

    const fieldValue = (name) => {
      const field = form?.elements[name];
      if (!field) return '–';
      if (typeof field.length === 'number' && !field.tagName) {
        return [...field].find((item) => item.checked)?.value?.trim() || '–';
      }
      return field.value?.trim() || '–';
    };

    const updateSelection = () => {
      q('[data-mq-selected-size]').textContent = `${size} CM`;
      q('[data-mq-selected-model]').textContent = modelName;
      q('[data-mq-selected-price]').textContent = price;
      q('[data-mq-model-property]').value = modelName;
      q('[data-mq-size-property]').value = `${size} CM`;
      q('[data-mq-price-property]').value = price;
      qa('[data-mq-payment-price]').forEach((item) => {
        item.textContent = sv ? price.toLowerCase() : `SEK ${price.replace(/\s*KR$/i, '')}`;
      });
      if (uploadLimit) {
        uploadLimit.textContent = sv
          ? 'JPG, PNG eller WEBP · minst 1 och högst 5 bilder'
          : 'JPG, PNG or WEBP · minimum 1 and maximum 5 images';
      }
      q('[data-mq-design-leg]').dataset.selectedSize = size;
      q('[data-mq-design-leg]').dataset.selectedModel = model;
      q('[data-mq-design-measure]').textContent = `${size} CM`;
      sessionStorage.setItem('mq-design-size', size);
      sessionStorage.setItem('mq-design-model', model);
      updateReview();
    };

    const selectButton = (button) => {
      size = button.dataset.mqDesignSize;
      model = button.dataset.model || '';
      modelName = button.dataset.modelName || `${size} CM`;
      price = button.dataset.price || '349 KR';
      const guard = q('[data-mq-design-guard]');
      if (guard && button.dataset.guardSrc) {
        guard.src = button.dataset.guardSrc;
        guard.alt = modelName;
      }
      qa('[data-mq-design-size]').forEach((item) => item.classList.toggle('is-selected', item === button));
      if (selectedFiles.length > maxFiles()) {
        selectedFiles = selectedFiles.slice(0, maxFiles());
        resetPreparedUploads();
        renderFiles();
      }
      updateSelection();
    };

    qa('[data-mq-design-size]').forEach((button) => {
      if (button.dataset.model === model) selectButton(button);
      button.addEventListener('click', () => selectButton(button));
    });

    const setProgress = (step) => {
      const items = [q('[data-mq-progress-size]'), q('[data-mq-progress-upload]'), q('[data-mq-progress-description]'), q('[data-mq-progress-contact]')];
      items.forEach((item, index) => {
        item.className = index + 1 < step ? 'is-complete' : index + 1 === step ? 'is-active' : '';
      });
    };

    const showUpload = () => {
      sizeStep.hidden = true;
      uploadStep.hidden = false;
      setProgress(2);
      updateSelection();
    };
    const showSize = () => {
      sizeStep.hidden = false;
      uploadStep.hidden = true;
      setProgress(1);
    };

    q('[data-mq-design-size-next]').addEventListener('click', () => {
      showUpload();
      scrollClean(uploadStep);
    });
    q('[data-mq-change-size]').addEventListener('click', () => {
      showSize();
      scrollClean(sizeStep);
    });
    if (errors) {
      showUpload();
      descriptionStep.hidden = false;
      descriptionActions.hidden = false;
      contactStep.hidden = false;
      setProgress(4);
      setTimeout(() => scrollClean(errors), 0);
    } else if (params.has('size')) showUpload();
    else showSize();

    const resetPreparedUploads = () => {
      preparedUploadedUrls = [];
      qa('[data-mq-upload-url]').forEach((field) => {
        field.value = '';
        field.removeAttribute('name');
        field.removeAttribute('value');
      });
      const linksField = q('[data-mq-upload-links]');
      if (linksField) linksField.value = '';
    };

    const renderFiles = () => {
      previews.innerHTML = '';
      selectedFiles.forEach((file, index) => {
        const figure = document.createElement('figure');
        const img = document.createElement('img');
        const remove = document.createElement('button');
        const url = URL.createObjectURL(file);
        img.src = url;
        img.alt = '';
        img.onload = () => URL.revokeObjectURL(url);
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', `${sv ? 'Ta bort' : 'Remove'} ${file.name}`);
        remove.addEventListener('click', () => {
          selectedFiles.splice(index, 1);
          resetPreparedUploads();
          renderFiles();
        });
        figure.append(img, remove);
        previews.append(figure);

      });

      const count = selectedFiles.length;
      descriptionNext.hidden = count < 1;
      uploadStatus.textContent = count
        ? `${count} ${sv ? 'AV' : 'OF'} ${maxFiles()} ${sv ? 'BILDER VALDA' : 'IMAGES SELECTED'}`
        : (sv ? 'BIFOGA MINST EN BILD FÖR ATT FORTSÄTTA' : 'ADD AT LEAST ONE IMAGE TO CONTINUE');
      updateReview();
      updateButtons();
    };

    const addFiles = (files) => {
      const previousCount = selectedFiles.length;
      [...files].filter((file) => file.type.startsWith('image/')).forEach((file) => {
        const duplicate = selectedFiles.some((item) => item.name === file.name && item.size === file.size && item.lastModified === file.lastModified);
        if (!duplicate && selectedFiles.length < maxFiles()) selectedFiles.push(file);
      });
      if (selectedFiles.length !== previousCount) resetPreparedUploads();
      renderFiles();
      input.value = '';
    };

    input.addEventListener('change', (event) => addFiles(event.target.files));
    const dropzone = q('[data-mq-dropzone]');
    ['dragenter', 'dragover'].forEach((name) => dropzone.addEventListener(name, (event) => {
      event.preventDefault();
      dropzone.classList.add('is-dragging');
    }));
    ['dragleave', 'drop'].forEach((name) => dropzone.addEventListener(name, (event) => {
      event.preventDefault();
      dropzone.classList.remove('is-dragging');
    }));
    dropzone.addEventListener('drop', (event) => addFiles(event.dataTransfer.files));

    const prepareSelectedImages = async () => {
      if (preparedUploadedUrls.length === selectedFiles.length && selectedFiles.length) return preparedUploadedUrls;
      if (isPreparingImages) return [];

      isPreparingImages = true;
      descriptionNext.disabled = true;
      const urls = [];
      try {
        for (let index = 0; index < selectedFiles.length; index += 1) {
          uploadStatus.textContent = sv
            ? `LADDAR UPP BILD ${index + 1} AV ${selectedFiles.length} …`
            : `UPLOADING IMAGE ${index + 1} OF ${selectedFiles.length} …`;
          urls.push(await uploadImage(selectedFiles[index]));
        }
        preparedUploadedUrls = urls;
        buildRequestBody(preparedUploadedUrls);
        uploadStatus.textContent = sv
          ? `${selectedFiles.length} AV ${maxFiles()} BILDER KLARA`
          : `${selectedFiles.length} OF ${maxFiles()} IMAGES READY`;
        return preparedUploadedUrls;
      } finally {
        isPreparingImages = false;
        descriptionNext.disabled = false;
      }
    };

    descriptionNext.addEventListener('click', async () => {
      if (!selectedFiles.length || isPreparingImages) return;
      try {
        const urls = await prepareSelectedImages();
        if (!urls.length) return;
        descriptionStep.hidden = false;
        descriptionActions.hidden = false;
        setProgress(3);
        updateReview();
        scrollClean(descriptionStep);
      } catch (error) {
        uploadStatus.textContent = sv
          ? `BILDERNA KUNDE INTE LADDAS UPP. FÖRSÖK IGEN. ${error.message || ''}`
          : `THE IMAGES COULD NOT BE UPLOADED. PLEASE TRY AGAIN. ${error.message || ''}`;
      }
    });

    qa('[data-mq-design-mode]').forEach((radio) => radio.addEventListener('change', () => {
      q('[data-mq-design-details]').hidden = radio.dataset.mqDesignMode !== 'details';
      updateReview();
    }));

    function updateReview() {
      const review = q('[data-mq-review]');
      if (!review || !form) return;
      const rows = [
        [sv ? 'Modell' : 'Model', modelName],
        [sv ? 'Storlek' : 'Size', `${size} CM`],
        [sv ? 'Bilder' : 'Images', `${selectedFiles.length} ${sv ? 'av' : 'of'} ${maxFiles()}`],
        [sv ? 'Designsätt' : 'Design method', fieldValue('contact[Designsätt]')],
        [sv ? 'Namn/initialer' : 'Name/initials', fieldValue('contact[Namn eller initialer]')],
        [sv ? 'Nummer' : 'Number', fieldValue('contact[Tröjnummer]')],
        [sv ? 'Text/citat' : 'Text/quote', fieldValue('contact[Egen text eller citat]')],
        [sv ? 'Flagga/klubbmärke' : 'Flag/club badge', fieldValue('contact[Flagga eller klubbmärke]')],
        [sv ? 'Placering' : 'Placement', fieldValue('contact[Placering]')],
        [sv ? 'Övrigt' : 'Other', fieldValue('contact[Övriga önskemål]')],
        [sv ? 'Pris efter godkänd design' : 'Price after design approval', price]
      ];
      review.innerHTML = rows.map(([key, value]) => `<div><dt>${key}</dt><dd>${value}</dd></div>`).join('');
    }

    const updateButtons = () => {
      contactOpen.disabled = !approval.checked || !termsApproval.checked || !selectedFiles.length;
      const selectedMethod = q('[data-mq-contact-method]:checked');
      const name = fieldValue('contact[Namn]');
      const detail = contactInput.value.trim();
      let validDetail = detail.length > 1;
      if (selectedMethod?.dataset.mqContactMethod === 'instagram') validDetail = detail.replace(/^@+/, '').trim().length > 1;
      if (selectedMethod?.dataset.mqContactMethod === 'email') validDetail = contactInput.validity.valid && detail.includes('@');
      requestSubmit.disabled = isSubmitting || !selectedMethod || !name || !validDetail || !approval.checked || !termsApproval.checked || !selectedFiles.length;
    };

    approval.addEventListener('change', updateButtons);
    termsApproval.addEventListener('change', updateButtons);
    formBody.addEventListener('input', () => {
      updateReview();
      if (preparedUploadedUrls.length === selectedFiles.length && selectedFiles.length) {
        buildRequestBody(preparedUploadedUrls);
      }
      updateButtons();
    });

    contactOpen.addEventListener('click', () => {
      if (contactOpen.disabled) return;
      if (preparedUploadedUrls.length === selectedFiles.length && selectedFiles.length) {
        buildRequestBody(preparedUploadedUrls);
      }
      contactStep.hidden = false;
      setProgress(4);
      createRequestId();
      scrollClean(contactStep);
    });

    const contactCopy = {
      whatsapp: {
        label: sv ? 'Ditt WhatsApp-nummer' : 'Your WhatsApp number',
        help: sv ? 'Skriv med landskod, till exempel +46 79 017 94 99.' : 'Include country code, for example +46 79 017 94 99.',
        placeholder: '+46 79 017 94 99',
        type: 'tel',
        autocomplete: 'tel'
      },
      instagram: {
        label: sv ? 'Ditt Instagram-konto' : 'Your Instagram account',
        help: sv ? 'Skriv bara användarnamnet. Du behöver inte skriva @.' : 'Enter only the username. You do not need to include @.',
        placeholder: 'användarnamn',
        type: 'text',
        autocomplete: 'off'
      },
      email: {
        label: sv ? 'Din e-postadress' : 'Your email address',
        help: sv ? 'Vi skickar designförslaget till denna adress.' : 'We will send the design proposal to this address.',
        placeholder: 'namn@exempel.se',
        type: 'email',
        autocomplete: 'email'
      }
    };

    qa('[data-mq-contact-method]').forEach((radio) => radio.addEventListener('change', () => {
      const config = contactCopy[radio.dataset.mqContactMethod];
      const contactEmailField = q('[data-mq-contact-email]');
      contactDetail.hidden = false;
      contactLabel.textContent = config.label;
      contactHelp.textContent = config.help;
      contactInput.type = config.type;
      contactInput.placeholder = config.placeholder;
      contactInput.autocomplete = config.autocomplete;
      contactInput.value = '';
      contactEmailField.value = merchantContactEmail;
      contactEmailField.setAttribute('value', merchantContactEmail);
      contactInput.focus();
      if (preparedUploadedUrls.length === selectedFiles.length && selectedFiles.length) {
        buildRequestBody(preparedUploadedUrls);
      }
      updateButtons();
    }));

    const uploadImage = async (file) => {
      const fileKey = `${file.name}:${file.size}:${file.lastModified}`;
      if (uploadedFileUrls.has(fileKey)) return uploadedFileUrls.get(fileKey);

      const body = new FormData();
      body.append('file', file);
      body.append('upload_preset', cloudinaryPreset);

      const response = await fetch(cloudinaryEndpoint, { method: 'POST', body });
      let result = {};
      try {
        result = await response.json();
      } catch (_error) {
        // The generic message below is clearer than exposing a parsing error.
      }

      if (!response.ok || !result.secure_url) {
        throw new Error(result?.error?.message || (sv ? 'Bilduppladdningen misslyckades.' : 'The image upload failed.'));
      }
      uploadedFileUrls.set(fileKey, result.secure_url);
      return result.secure_url;
    };

    function buildRequestBody(uploadedUrls) {
      const id = createRequestId();
      const imageLinks = uploadedUrls.map((url, index) => `Bild ${index + 1} (${selectedFiles[index]?.name || 'bild'}): ${url}`).join('\n');
      qa('[data-mq-upload-url]').forEach((field, index) => {
        const url = uploadedUrls[index] || '';
        field.value = url;
        if (url) {
          field.name = `contact[Bild ${index + 1} – klicka för att öppna]`;
          field.setAttribute('value', url);
        } else {
          field.removeAttribute('name');
          field.removeAttribute('value');
        }
      });
      q('[data-mq-upload-links]').value = imageLinks;
      const optionalLines = [
        ['Måste vara med', fieldValue('contact[Måste vara med]')],
        ['Namn/initialer', fieldValue('contact[Namn eller initialer]')],
        ['Tröjnummer', fieldValue('contact[Tröjnummer]')],
        ['Text/citat', fieldValue('contact[Egen text eller citat]')],
        ['Flagga/klubbmärke', fieldValue('contact[Flagga eller klubbmärke]')],
        ['Övrigt', fieldValue('contact[Övriga önskemål]')]
      ].filter(([, value]) => value && value !== '–').map(([label, value]) => `${label}: ${value}`);
      const selectedContactMethod = q('[data-mq-contact-method]:checked')?.dataset.mqContactMethod;
      const rawContactDetail = fieldValue('contact[Kontaktuppgift]');
      const contactDetailValue = selectedContactMethod === 'instagram'
        ? rawContactDetail.replace(/^@+/, '').trim()
        : rawContactDetail;
      const lines = [
        `𝗞𝗨𝗡𝗗: ${fieldValue('contact[Namn]')}`,
        `𝗞𝗢𝗡𝗧𝗔𝗞𝗧: ${fieldValue('contact[Kontaktväg]')} – ${contactDetailValue}`,
        '',
        '𝗕𝗜𝗟𝗗𝗘𝗥',
        imageLinks,
        '',
        `𝗠𝗢𝗗𝗘𝗟𝗟: ${modelName} (${size} CM)`,
        '',
        '𝗗𝗘𝗦𝗜𝗚𝗡',
        `Designsätt: ${fieldValue('contact[Designsätt]')}`,
        `Placering: ${fieldValue('contact[Placering]')}`,
        ...optionalLines
      ];
      q('[data-mq-request-id]').value = id;
      q('[data-mq-request-body]').value = lines.join('\n').replace(/\n{3,}/g, '\n\n');
      const contactEmailValue = selectedContactMethod === 'email' && contactInput.validity.valid && contactInput.value.trim().includes('@')
        ? contactInput.value.trim()
        : merchantContactEmail;
      q('[data-mq-contact-email]').value = contactEmailValue;
      q('[data-mq-contact-email]').setAttribute('value', contactEmailValue);
    }

    const compactEmailFields = () => {
      if (emailFieldsCompacted) return;
      qa('[name^="contact["]').forEach((field) => {
        if (field.matches('[data-mq-contact-email], [data-mq-request-body]')) return;
        field.disabled = true;
        field.dataset.mqEmailDisabled = 'true';
      });
      emailFieldsCompacted = true;
    };

    const restoreEmailFields = () => {
      qa('[data-mq-email-disabled]').forEach((field) => {
        field.disabled = false;
        delete field.dataset.mqEmailDisabled;
      });
      emailFieldsCompacted = false;
    };

    requestSubmit.addEventListener('click', () => {
      if (preparedUploadedUrls.length === selectedFiles.length && selectedFiles.length) {
        buildRequestBody(preparedUploadedUrls);
        compactEmailFields();
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (isSubmitting) return;
      updateButtons();
      if (requestSubmit.disabled) {
        status.textContent = sv ? 'FYLL I NAMN OCH KONTAKTUPPGIFT FÖR ATT FORTSÄTTA.' : 'ENTER YOUR NAME AND CONTACT DETAILS TO CONTINUE.';
        return;
      }
      if (preparedUploadedUrls.length === selectedFiles.length && selectedFiles.length) {
        buildRequestBody(preparedUploadedUrls);
        compactEmailFields();
      }

      isSubmitting = true;
      updateButtons();

      try {
        status.textContent = sv ? 'FÖRBEREDER BILDER …' : 'PREPARING IMAGES …';
        const uploadedUrls = await prepareSelectedImages();
        if (!uploadedUrls.length) throw new Error(sv ? 'Inga bildlänkar skapades.' : 'No image links were created.');
        buildRequestBody(uploadedUrls);
        sessionStorage.setItem('mq-design-contact-method', fieldValue('contact[Kontaktväg]'));
        status.textContent = sv ? 'SKICKAR DESIGNFÖRFRÅGAN …' : 'SENDING DESIGN REQUEST …';
        form.submit();
      } catch (error) {
        isSubmitting = false;
        restoreEmailFields();
        status.textContent = sv
          ? `BILDERNA KUNDE INTE LADDAS UPP. FÖRSÖK IGEN. ${error.message || ''}`
          : `THE IMAGES COULD NOT BE UPLOADED. PLEASE TRY AGAIN. ${error.message || ''}`;
        updateButtons();
      }
    });

    updateSelection();
    renderFiles();
    updateButtons();
  });
};

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', initMqDesignPages)
  : initMqDesignPages();
document.addEventListener('shopify:section:load', initMqDesignPages);
